<template>
  <Toast />
  
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row mb-4">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>REPORTE DE PRODUCTOS MÁS VENDIDOS</strong>
      </span>
    </div>

    <!-- Filtros reutilizables -->
    <DashboardFilter 
      @aplicar-filtros="onAplicarFiltros"
      :loading="cargando"
      :mostrarFiltroCanal="true"
    />



    <!-- Tabla de resultados -->
    <div class="mt-4">
      <DataTable
        ref="dt"
        :value="productos"
        responsiveLayout="scroll"
        :loading="cargando"
        class="p-datatable-sm"
        :filters="buscar"
        responsive="true"
        stripedRows
        rowHover
        showGridlines
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10,25,50]"
      >
        <template #header>
          <div class="flex flex-column md:flex-row md:justify-content-end md:align-items-end">
            <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">              
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar producto..."
              />
            </span>
            <!-- <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
              <Button
                label="EXCEL Exportar"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success"
                v-tooltip.top="'Exportar Reporte Excel'"
                :loading="exportando"
                :disabled="exportando || productos.length === 0"
                @click="exportarExcel"
              />
            </span> -->
          </div>
        </template>
        <template #empty>
          <span class="p-invalid">Debe aplicar filtros para ver resultados o no hay datos para los filtros seleccionados.</span>
        </template>
        
        <Column header="Nº" style="width:3rem">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <!-- <Column field="producto_id" header="CÓDIGO" :sortable="true"></Column> -->
        <Column field="producto" header="PRODUCTO" :sortable="true"></Column>
        <Column field="categoria" header="CATEGORÍA / GRUPO" :sortable="true"></Column>
        <Column field="subcategoria" header="SUBCATEGORÍA" :sortable="true">
          
        </Column>
        <Column field="sucursal" header="SUCURSAL" :sortable="true"></Column>
        <Column field="canal" header="CANAL" :sortable="true">
        <template #footer>
            <div class="text-right w-full">
              <span class="p-badge p-badge-info p-badge-lg">TOTAL:</span>
            </div>
          </template>
        </Column>
        <Column field="unidades_vendidas" header="CANT. VENDIDA" class="text-right" :sortable="true">
          <template #body="{ data }">
            <span style="font-weight:bold;">
              {{ convertirNumeroGermanicFormat(data.unidades_vendidas) }}
            </span>
          </template>
          <template #footer>
            <div class="text-right w-full">
              <span class="p-badge p-badge-success p-badge-lg">
                {{ convertirNumeroGermanicFormat(totalUnidadesVendidas) }}
              </span>
            </div>
          </template>
        </Column>
        <!-- <Column field="monto_vendido" header="TOTAL RECAUDADO (Bs.)" class="text-right" :sortable="true">
          <template #body="{ data }">
            <span style="font-weight:bold;">
              {{ convertirNumeroGermanicFormat(data.monto_vendido) }}
            </span>
          </template>
          <template #footer>
            <div class="text-right w-full">
              <span class="p-badge p-badge-success p-badge-lg">
                {{ convertirNumeroGermanicFormat(totalMontoVendido) }}
              </span>
            </div>
          </template>
        </Column> -->
      </DataTable>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import DashboardFilter from "@/components/DashboardFilter.vue";
import ReporteService from "@/service/ReporteService";

export default {
  name: "ProductoMasVendido",
  components: {
    DashboardFilter
  },
  data() {
    return {
      cargando: false,
      exportando: false,
      productos: [],
      filtrosActuales: null,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
    };
  },
  created() {
    this.reporteService = new ReporteService();
  },
  computed: {
    totalUnidadesVendidas() {
      if (!this.productos) return 0;
      return this.productos.reduce((acc, curr) => acc + (Number(curr.unidades_vendidas) || 0), 0);
    },
    totalMontoVendido() {
      if (!this.productos) return 0;
      return this.productos.reduce((acc, curr) => acc + (Number(curr.monto_vendido) || 0), 0);
    }
  },
  methods: {
    onAplicarFiltros(filtros) {
      this.filtrosActuales = filtros;
      this.cargarReporte();
    },
    async cargarReporte() {
      if (!this.filtrosActuales) return;
      
      this.cargando = true;
      try {
        const payload = {
          fecha_inicio: this.filtrosActuales.fecha_inicio,
          fecha_fin: this.filtrosActuales.fecha_fin,
        };

        if (this.filtrosActuales.sucursal_id) {
          payload.sucursal_id = this.filtrosActuales.sucursal_id;
        }
        
        if (this.filtrosActuales.grupo_ids) {
          payload.grupo_ids = this.filtrosActuales.grupo_ids;
        }

        if (this.filtrosActuales.canal_venta_id) {
          payload.canal_venta_id = this.filtrosActuales.canal_venta_id;
        }

        const response = await this.reporteService.productosMasVendidos(payload);
        console.log("Respuesta de la API:", response);
        // Dependiendo de cómo el backend envíe los datos, puede ser response, response.data, o response.productos
        this.productos = response.data || response.productos || (Array.isArray(response) ? response : []);

      } catch (error) {
        console.error("Error al cargar reporte:", error);
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo cargar el reporte', life: 3000 });
      } finally {
        this.cargando = false;
      }
    },
    exportarExcel() {
      // TODO: Conectar a la lógica de exportación en backend si es necesario
      this.$toast.add({ severity: 'info', summary: 'Info', detail: 'Funcionalidad de exportación pendiente', life: 3000 });
    },
    convertirNumeroGermanicFormat(numero) {
      if(numero === undefined || numero === null) return '0,00';
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
  }
};
</script>

<style scoped>
:deep(.p-datatable-hoverable-rows .p-datatable-tbody > tr:not(.p-highlight):hover) {
  background-color: #e6f3f8 !important; /* Celeste suave a juego con tu borde */
  color: #000 !important;
}
</style>
